import styled, { css } from 'styled-components';
import { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Link as RouterLink } from 'components/common/link';
import { color } from 'constants/styled-theme';
import { LoginButton } from 'components/login-button';
import { useDispatch } from 'react-redux';
import { ROUTE_PATHS } from 'routes';
import { BasicButton } from 'components/common/button';
import { changeTab } from 'components/active-auctions/actions';
import { useTokenData } from 'hooks';

const Container = styled.div`
  display: none;
  @media screen and (max-width: ${p => p.theme.mobile}) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 65px;
    flex-direction: row;
    position: fixed;
    top: 0;
    z-index: 99999;
    width: 100%;
    background-color: #f8f3f3;
  }
  a {
    text-align: center;
  }
`;

const MenuHumburgerIcon = styled.label`
  position: fixed;
  top: 20px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  background-color: #f8f3f3;
  z-index: 999;
  ${p =>
    p.isOpen
      ? css`
          right: 20px;
          border-radius: 50%;
          border: 1px solid;
        `
      : css`
          left: 20px;
        `}
  span {
    display: block;
    position: absolute;
    width: ${p => (p.isOpen ? 50 : 100)}%;
    height: ${p => (p.isOpen ? 0 : 2)}px;
    background-color: ${p => (p.isOpen ? '#616161' : color('activeMenuColor'))};
    transition-duration: 0.25s;
    &:before,
    &:after {
      display: block;
      position: absolute;
      width: 100%;
      height: 2px;
      background-color: ${p => (p.isOpen ? '#616161' : color('activeMenuColor'))};
      transition-duration: 0.25s;
    }
    ${p =>
      p.isOpen
        ? css`
            transform: rotate(45deg);
            &:before {
              content: '';
              top: 5px;
              left: 16px;
              transform: rotate(0deg);
            }
            &:after {
              content: '';
              top: 5px;
              left: 16px;
              transform: rotate(90deg);
            }
          `
        : css`
            &:before {
              content: '';
              top: -8px;
            }
            &:after {
              content: '';
              top: 8px;
            }
          `}
  }
`;

const RapLogo = styled.div`
  font-size: 1.8rem;
  font-family: ${props => props.theme.fonts.bold};
  color: ${color('red50')};
`;
const JewelLogo = styled.div`
  font-size: 1rem;
  font-family: ${props => props.theme.fonts.bold};
`;

const Menu = styled.ul`
  display: block;
  position: fixed;
  list-style: none;
  padding-left: 0;
  top: 0;
  left: ${p => (p.isOpen ? 0 : '-102%')};
  width: 100%;
  margin: 0;
  background-color: #f8f3f3;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transition-duration: 0.25s;
  padding-top: 35px;
  z-index: 998;
  bottom: 0;
  overflow-y: scroll;
`;

const MenuItem = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 30px 24px 21px;
  font-size: 18px;
  font-family: ${props => props.theme.fonts.regular};
  border-bottom: 1px solid #707070;
  text-decoration: none;
  transition-duration: 0.25s;
  ${p =>
    p.isSub &&
    css`
      padding-left: 30px;
      a {
        color: ${color('activeMenuColor')} !important;
      }
    `}
  a {
    font-size: 18px;
    text-transform: uppercase;
    font-family: ${props => props.theme.fonts.regular};
    color: ${prop => (prop.selected ? color('gray0') : color('fontColor'))};
  }
  background-color: ${prop => (prop.selected ? color('activeMenuColor') : 'none')};
  color: ${prop => (prop.selected ? color('gray0') : color('fontColor'))};
`;

const SubMenuItem = styled.li`
  display: block;
  color: ${color('activeMenuColor')};
  font-size: 18px;
  font-family: ${props => props.theme.fonts.regular};
  text-decoration: none;
  transition-duration: 0.25s;
  border-bottom: 1px solid #707070;
  a {
    font-size: 18px;
    text-transform: uppercase;
    font-family: ${props => props.theme.fonts.regular};
    padding: 30px 0;
    div {
      bottom: -3px;
    }
  }
  &:hover {
    background-color: #cfd8dc;
  }
`;

const MenuTab = styled(RouterLink)`
  width: 100%;
  color: color('activeMenuColor');
  // font-family: ${props => props.theme.fonts.regular};
  // background-color: ${prop => (prop.match ? color('activeMenuColor') : 'none')};
  // color: ${prop => (prop.selected ? color('gray0') : 'fontColor')};
`;

const SubMenuButton = styled(BasicButton)`
  width: 100%;
  font-size: 18px;
  text-transform: uppercase;
  font-family: ${props => props.theme.fonts.regular};
  color: ${p => (p.open ? color('gray0') : color('fontColor'))};
  background-color: ${p => (p.open ? color('activeMenuColor') : 'none')};
  text-align: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  &:focus {
    outline: none;
  }
`;

const ArrowSubMenu = styled.div`
  top: ${p => (p.open ? 4 : 2)}px;
  height: 8px;
  width: 8px;
  border-style: solid;
  border-width: 0px 1px 1px 0px;
  transform: ${p => (p.open ? 'rotate(225deg)' : 'rotate(45deg)')};
  transition: border-width 150ms ease-in-out;
  border-color: ${p => (p.open ? color('gray0') : color('gray80'))};
  position: relative;
`;

const ArrowContainer = styled.div`
  width: 15px;
  height: 15px;
  margin-left: 10px;
`;

const SubMenutTab = styled(RouterLink)`
  height: 100%;
  padding: 30px 0;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 12px;
  font-family: ${props => props.theme.fonts.regular};
  color: ${color('activeMenuColor')};
  &:hover .hover-line {
    opacity: 1;
  }
`;

export const MobileHeader = () => {
  const { isAuth, isSeller, isBuyer } = useTokenData();
  const [isOpenMenu, setIsOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState([]);
  const isAboutRoute = useRouteMatch(ROUTE_PATHS.ABOUT);
  const homeRoute = useRouteMatch(ROUTE_PATHS.HOME);
  const howItWorksRoute = useRouteMatch(ROUTE_PATHS.HOW_IT_WORKS);
  const termsAndConditions = useRouteMatch(ROUTE_PATHS.TERMS_AND_CONDITIONS);
  const faq = useRouteMatch(ROUTE_PATHS.FAQ);
  const isFaqRoutes = howItWorksRoute || termsAndConditions || faq;
  const contactPage = useRouteMatch(ROUTE_PATHS.CONTACT);
  const isMyLots = useRouteMatch(ROUTE_PATHS.MY_LOTS);
  const isMyBids = useRouteMatch(ROUTE_PATHS.MY_BIDS);
  const isActiveAuctions = useRouteMatch(ROUTE_PATHS.ACTIVE_AUCTIONS);
  const isMyAccountTab = !!isMyLots || !!isMyBids;
  const isCatalogTab = CONFIG.AUCTION_TYPE === 'collection';
  const dispatch = useDispatch();
  const onClickMenu = () => {
    dispatch(changeTab());
    setIsOpen(false);
  };
  const openSubSection = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    if (subMenuOpen.length > 0 && subMenuOpen.includes(value)) {
      setSubMenuOpen([]);
    } else {
      setSubMenuOpen([value]);
    }
  };

  const openMenu = () => {
    setIsOpen(!isOpenMenu);
  };

  return (
    <Container>
      <MenuHumburgerIcon onClick={e => openMenu(e)} isOpen={isOpenMenu}>
        <span />
      </MenuHumburgerIcon>
      <RouterLink to="/">
        <RapLogo>RAPAPORT</RapLogo>
        <JewelLogo>{`JEWELRY ${isCatalogTab ? 'COLLECTION' : 'AUCTIONS'}`}</JewelLogo>
      </RouterLink>
      <LoginButton />
      <Menu isOpen={isOpenMenu}>
        <MenuItem selected={!!homeRoute}>
          <MenuTab to={ROUTE_PATHS.ACTIVE_AUCTIONS} onClick={onClickMenu}>
            HOME
          </MenuTab>
        </MenuItem>
        <MenuItem selected={!!isAboutRoute}>
          <MenuTab to={ROUTE_PATHS.ABOUT}>About</MenuTab>
        </MenuItem>
        <MenuItem selected={!!isActiveAuctions}>
          <MenuTab to={ROUTE_PATHS.ACTIVE_AUCTIONS} onClick={onClickMenu}>
            {!isCatalogTab ? 'AUCTION' : 'COLLECTIONS'}
          </MenuTab>
        </MenuItem>
        <MenuItem
          selected={subMenuOpen.includes('faq') || !!isFaqRoutes}
          onClick={e => openSubSection(e, 'faq')}
        >
          <SubMenuButton open={subMenuOpen.includes('faq') || !!isFaqRoutes}>
            How it works
            <ArrowContainer>
              <ArrowSubMenu open={subMenuOpen.includes('faq') || !!isFaqRoutes} />
            </ArrowContainer>
          </SubMenuButton>
        </MenuItem>
        {subMenuOpen.includes('faq') ? (
          <>
            <MenuItem isSub>
              <MenuTab to={ROUTE_PATHS.HOW_IT_WORKS}>How it Works</MenuTab>
            </MenuItem>
            <MenuItem isSub>
              <MenuTab to={ROUTE_PATHS.FAQ}>FAQ</MenuTab>
            </MenuItem>
            <MenuItem isSub>
              <MenuTab to={ROUTE_PATHS.TERMS_AND_CONDITIONS}>Terms and conditions</MenuTab>
            </MenuItem>
          </>
        ) : null}
        {isAuth && (
          <MenuItem
            selected={subMenuOpen.includes('my_account') || !!isMyAccountTab}
            onClick={e => openSubSection(e, 'my_account')}
          >
            <SubMenuButton open={subMenuOpen.includes('my_account') || !!isMyAccountTab}>
              My Account
              <ArrowContainer>
                <ArrowSubMenu open={subMenuOpen.includes('my_account') || !!isMyAccountTab} />
              </ArrowContainer>
            </SubMenuButton>
          </MenuItem>
        )}
        {subMenuOpen.includes('my_account') ? (
          <>
            {isSeller && (
              <SubMenuItem>
                <SubMenutTab onClick={onClickMenu} to={ROUTE_PATHS.MY_LOTS}>
                  My Lots For Sale
                </SubMenutTab>
              </SubMenuItem>
            )}
            {isBuyer && (
              <SubMenuItem>
                <SubMenutTab onClick={onClickMenu} to={ROUTE_PATHS.MY_BIDS}>
                  {isCatalogTab ? 'My Offers' : 'My Bids'}
                </SubMenutTab>
              </SubMenuItem>
            )}
          </>
        ) : null}
        <MenuItem selected={!!contactPage}>
          <MenuTab selected={!!contactPage} to={ROUTE_PATHS.CONTACT}>
            CONTACT
          </MenuTab>
        </MenuItem>
      </Menu>
    </Container>
  );
};
